import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getToken } from "../../../utils/session-utils";

const SecuredRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      getToken() ? <Component {...props} /> : <Redirect to="/" />
    }
  />
);

export default SecuredRoute;
